import { $api } from "../../../../../services/request.config";
import { getStructureTopThunkAction } from "../../../LeaderRequests/thunk/getStructureTop.thunk.action";
import { getUserRequestsThunkAction } from "../../../GetUserRequests/thunk/getUserRequests.thunk.action";

export const sendMemoThunkAction = (data) => async (dispatch) => {
    const { uid, employees, props } = data;
    try {
        const response = await $api.post(`/v1/managers/requests/rvd/applications/${uid}/memo`, { agreements: employees });
        if (response.status) {
            // dispatch(getStructureTopThunkAction());
            // dispatch(
            //     getUserRequestsThunkAction({
            //         page: {
            //             pageSize: 5,
            //             pageNumber: 1,
            //         },
            //     }),
            // );
        }
    } catch (e) {

    }
};
